import { render, staticRenderFns } from "./DataNavigation.vue?vue&type=template&id=b9a4df14&scoped=true"
import script from "./DataNavigation.vue?vue&type=script&lang=js"
export * from "./DataNavigation.vue?vue&type=script&lang=js"
import style0 from "./DataNavigation.vue?vue&type=style&index=0&id=b9a4df14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a4df14",
  null
  
)

export default component.exports